import { render, staticRenderFns } from "./AsientosComponent.vue?vue&type=template&id=34d58d57"
import script from "./AsientosComponent.vue?vue&type=script&lang=js"
export * from "./AsientosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports